import React from 'react';
import Reveal from '../ui/Reveal';

const WhyUs = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          
          <Reveal direction="right">
            <div>
              <h2 className="font-serif text-4xl md:text-5xl text-navy-900 mb-8">Our Edge</h2>
              <div className="space-y-8">
                <div>
                  <h4 className="text-xl font-medium text-navy-900 mb-2">Author-Led Storytelling Instinct</h4>
                  <p className="text-gray-600 font-light">We don't just write press releases; we craft compelling narratives that journalists actually want to read and audiences want to share.</p>
                </div>
                <div>
                  <h4 className="text-xl font-medium text-navy-900 mb-2">Literary Precision</h4>
                  <p className="text-gray-600 font-light">Every word is chosen with intent. Our background in literature ensures your brand's voice is sophisticated, clear, and impactful.</p>
                </div>
                <div>
                  <h4 className="text-xl font-medium text-navy-900 mb-2">Media-First Thinking</h4>
                  <p className="text-gray-600 font-light">We anticipate what the media needs before they ask, positioning you as the go-to expert in your field.</p>
                </div>
              </div>
            </div>
          </Reveal>

          <Reveal direction="left" delay={0.2}>
            <div className="bg-navy-900 p-12 relative overflow-hidden">
              {/* Decorative background pattern */}
              <div className="absolute top-0 right-0 w-64 h-64 bg-white opacity-5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2"></div>
              
              <div className="relative z-10 text-center space-y-12">
                <div>
                  <span className="block font-serif text-6xl text-gold-500 mb-2">500+</span>
                  <span className="text-white uppercase tracking-widest text-sm">Stories Told</span>
                </div>
                <div className="w-12 h-[1px] bg-gray-700 mx-auto"></div>
                <div>
                  <span className="block font-serif text-4xl text-white mb-2 italic">Countless</span>
                  <span className="text-gray-400 uppercase tracking-widest text-sm">Headlines Made</span>
                </div>
              </div>
            </div>
          </Reveal>

        </div>
      </div>
    </section>
  );
};

export default WhyUs;